import {useEffect} from 'react';
import {getQueryParams} from '@core/lib/urls';
import Loading from '@core/ui/Loading';

const getSafeRedirectPath = () => {
  const {to} = getQueryParams();
  if (!to) return '/';

  try {
    const parsed = new URL(to, window.location.origin);
    if (parsed.origin !== window.location.origin) return '/';
    return parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return '/';
  }
};

const Enter = ({
  match: {
    params: {token},
  },
}: {
  match: {params: {token: string}};
}) => {
  useEffect(() => {
    localStorage.setItem('adanalytics-token', token);
    window.location = getSafeRedirectPath();
  }, [token]);

  return <Loading fixed />;
};

export default Enter;
